import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files
import en from './locales/en.json'
import ur from './locales/ur.json'
import fa from './locales/fa.json'
import ar from './locales/ar.json'

const resources = {
  en: {
    translation: en
  },
  ur: {
    translation: ur
  },
  fa: {
    translation: fa
  },
  ar: {
    translation: ar
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },

    interpolation: {
      escapeValue: false
    }
  })

export default i18n
